export default __webpack_public_path__ + "static/media/frooti.5574d30a.png";